import classNames from 'classnames';
import { Link, useLocation } from 'react-router-dom';

import { NavbarItemTypes } from '../type';
import { NAVBAR_ITEMS } from '../util/constants';
import UserOptionsDropdown from './UserOptionsDropdown';
import MemberCardCompareInfo from './v2/MemberCardCompareInfo';
import PermissionSettingModal from './v2/PermissionSettingModal';

interface IProps {
  className?: string;
}

const Navbar = ({ className }: IProps) => {
  const location = useLocation();

  return (
    <div
      className={classNames('bg-transparent flex items-center justify-between pl-8.5 pr-10.5', {
        [`${className}`]: className
      })}
    >
      <Link to="/">
        <div className="aspect-[213/43]">
          <img src="/images/navbar/sacurn-logo.svg" alt="sacurn" />
        </div>
      </Link>
      <div className="flex items-center">
        <nav>
          <ul className="flex items-center justify-between gap-8">
            {NAVBAR_ITEMS?.map((item: NavbarItemTypes) => (
              <li
                key={item.name}
                className={classNames('', {
                  'border-b border-white': location.pathname === item.path
                })}
              >
                <Link to={item.path} className="text-white text-xl font-normal">
                  {item.name}
                </Link>
              </li>
            ))}
          </ul>
        </nav>
        <div className="flex items-center pl-4 ml-6 border-l border-[#ccc]">
          <UserOptionsDropdown />
        </div>
        {/* <div className="flex items-center 2xl:gap-9 gap-5 2xl:ml-17 ml-12">
          <Link to="/cart">
            <img
              src="/images/navbar/cart.svg"
              alt="sacurn"
              className="2xl:w-9 w-7 2xl:h-9 h-7 cursor-pointer pt-1"
              width={35}
              height={34}
            />
          </Link>
          <UserOptionsDropdown />
        </div> */}
      </div>
      <MemberCardCompareInfo />
      <PermissionSettingModal />
    </div>
  );
};

export default Navbar;
